export default {
  name: "CustomTabs",
  props: {
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultActive: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: this.defaultActive,
      indicatorStyle: {
        width: "0px",
        left: "0px"
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateIndicator();
    });
  },
  methods: {
    switchTab(index) {
      this.activeIndex = index;
      this.updateIndicator();
      this.$emit("tab-change", index, this.tabs[index]);
    },
    updateIndicator() {
      if (this.$refs.tabItems && this.$refs.tabItems[this.activeIndex]) {
        const activeTab = this.$refs.tabItems[this.activeIndex];
        const {
          offsetLeft,
          offsetWidth
        } = activeTab;
        this.indicatorStyle = {
          width: `${offsetWidth}px`,
          left: `${offsetLeft}px`
        };
      }
    }
  },
  watch: {
    activeIndex() {
      this.$nextTick(() => {
        this.updateIndicator();
      });
    }
  }
};